const logos = [
  "Turespacio",
  "Incubatour",
  "VisitMéxico",
  "SECTUR",
  "AMAV",
  "WTM Latin America",
  "FITUR",
  "Tianguis Turístico",
  "CPTM",
  "ATMEX",
];

export default function Clientes() {
  // Duplicate for seamless marquee
  const track = [...logos, ...logos];

  return (
    <section
      data-testid="clientes-section"
      className="relative bg-black py-20 md:py-28 border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10">
        <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-white/50">
          <span className="h-px w-8 bg-white/40" /> Confianza
        </div>
        <h2 className="font-display mt-4 text-2xl md:text-3xl uppercase tracking-tight text-white/80 max-w-3xl">
          Marcas que han apostado por la
          <span className="text-white"> locura con método</span>.
        </h2>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-black to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-black to-transparent pointer-events-none" />

        <div className="overflow-hidden">
          <div className="marquee-track flex items-center gap-16 whitespace-nowrap py-4">
            {track.map((name, i) => (
              <div
                key={`${name}-${i}`}
                data-testid={`logo-${i}`}
                className="flex items-center gap-3 shrink-0 group"
              >
                <span className="h-2 w-2 bg-white/30 group-hover:bg-white transition-colors" />
                <span className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white/40 group-hover:text-white transition-colors">
                  {name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-white/50 text-sm max-w-md">
          + de <strong className="text-white">5,000 productos turísticos</strong>{" "}
          rentables diseñados para destinos, hoteles, tour operadores y
          gobiernos en Iberoamérica.
        </p>
        <a
          href="#contacto"
          data-testid="clientes-cta"
          className="btn-block btn-ghost"
        >
          Suma tu marca →
        </a>
      </div>
    </section>
  );
}
